import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ModalService } from '@app/@core/modal/modal.service';
import { SpinnerService } from '@app/@shared/spinner/spinner.service';
import { StudyModel, Survey } from '@app/interface';
import { UserGroupModel } from '@app/interface/userGroup.model';
import { ProviderDataValidators as Validators } from '@app/modules/data-valiidator';
import { EmailTemplatesService, SurveyService, UserGroupService, UserService } from '@app/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs/operators';
import { EmailTemplate } from '@app/interface/emailTemplate';
import { UserGroupFormModel } from '@app/formModels';

@Component({
  selector: 'app-add-schedule',
  templateUrl: './add-schedule.component.html',
  styleUrls: ['./add-schedule.component.scss'],
})
export class AddScheduleComponent implements OnInit {
  scheduleForm: FormGroup;
  submitted = false;
  success: boolean;
  date = new Date().toISOString();
  isLoading = false;
  @Input() title_tag: string;
  @Input() formType: string;
  @Input() form_data: any;
  studyDetail: StudyModel;
  userGroupsOptins: Array<UserGroupModel> = [];
  userGroups: Array<UserGroupModel> = [];
  @Input() show_answers: boolean = false;
  surveyDataTable: any[] = [];
  wearables = ['Fitbit', 'Apple'];
  mandatoryOptions = ['Optional', 'Mandatory'];
  today = new Date();
  showEmailTemplates: boolean = false;
  emailTemplate: EmailTemplate[] = [];

  arr: any[] = [];
  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerService,
    public userService: UserService,
    public surveyService: SurveyService,
    private modalService: ModalService,
    private emailTemplatesService: EmailTemplatesService,
    private userGroupService: UserGroupService
  ) {}

  ngOnInit() {
    this.getEmailTemplates();
    this.getUserGroups();
    this.createForm();
    this.getSurveys();
  }

  public isFormTypeEdit(formType: string) {
    return formType == 'Edit' ? true : false;
  }

  newOption(existingData?: any): FormGroup {
    existingData ? this.arr.push(existingData.instrumentName) : null;
    return this.formBuilder.group({
      instrumentName: [existingData ? existingData.instrumentName : '', [Validators.required()]],
      startDate: [existingData ? existingData.startDate : '', [Validators.required()]],
      endDate: [existingData ? existingData.endDate : '', [Validators.required()]],
      userReminders: [existingData ? existingData.userReminders : '', [Validators.required()]],
    });
  }

  newWearableOption(existingData?: any): FormGroup {
    existingData ? this.arr.push(existingData.wearableName) : null;
    return this.formBuilder.group({
      wearableName: [existingData ? existingData.wearableName : '', [Validators.required()]],
      startDate: [existingData ? existingData.startDate : '', [Validators.required()]],
      endDate: [existingData ? existingData.endDate : '', [Validators.required()]],
      minDays: [existingData ? existingData.minDays : '', [Validators.required()]],
      isOptional: [existingData ? existingData.isOptional : '', [Validators.required()]],
    });
  }

  private createForm(): void {
    this.scheduleForm = this.formBuilder.group({
      uuid: [''],
      step: ['', [Validators.required()]],
      stepStatus: [this.isFormTypeEdit(this.formType) ? this.form_data['stepStatus'] : 'SCHEDULED'],
      startDate: ['', [Validators.required()]],
      endDate: ['', [Validators.required()]],
      options:
        this.isFormTypeEdit(this.formType) && this.form_data['options'] !== undefined
          ? this.formBuilder.array(this.form_data['options'].map((r: any) => this.newOption(r)))
          : this.formBuilder.array([]),
      studyId: [localStorage.getItem('studyId'), [Validators.required]],
      isNotify: [this.isFormTypeEdit(this.formType) ? this.form_data['isNotify'] : false],
      emailTemplateId: [this.isFormTypeEdit(this.formType) ? this.form_data['emailTemplateId'] : ''],
      // reminderEmailTemplateId: [
      //   this.isFormTypeEdit(this.formType) ? this.form_data['reminderEmailTemplateId'] : '',
      //   [Validators.required()],
      // ],
      userGroupId: [this.isFormTypeEdit(this.formType) ? this.form_data['userGroupId'] : ''],
      wearableOptions:
        this.isFormTypeEdit(this.formType) && this.form_data['wearableOptions'] !== undefined
          ? this.formBuilder.array(this.form_data['wearableOptions'].map((r: any) => this.newWearableOption(r)))
          : this.formBuilder.array([]),
    });
    if (this.formType === 'Edit') {
      this.scheduleForm.patchValue(this.form_data);
      this.showEmailTemplates = this.form_data['isNotify'];
    }
  }

  get formControl() {
    return this.scheduleForm.controls;
  }

  public save(): void {
    this.submitted = true;
    if (this.scheduleForm.valid) {
      const accessData = this.scheduleForm.value;
      this.isLoading = true;
      this.spinnerService.show();
      if (this.formType === 'Edit') {
        this.updateSchedules(accessData);
      } else {
        this.addSchedules(accessData);
      }
    } else {
      return;
    }
  }

  private addSchedules(schedule: any): void {
    schedule?.options?.forEach((option: any) => {
      option.instrumentName['surveyStartDate'] = option?.startDate;
      option.instrumentName['surveyEndDate'] = option?.endDate;
      option.instrumentName['userReminders'] = option?.userReminders;
    });
    this.userService.addSchedules(schedule).subscribe(() => {
      this.isLoading = false;
      this.submitted = false;
      this.activeModal.close(true);
      this.spinnerService.hide();

      schedule?.options?.forEach((option: any) => {
        option.instrumentName['surveyStartDate'] = option?.startDate;
        option.instrumentName['surveyEndDate'] = option?.endDate;
        option.instrumentName['userReminders'] = option?.userReminders;
        this.surveyService.updateSurvey(option.instrumentName).subscribe();
      });
    });
  }

  private updateSchedules(accessData: any): void {
    this.userService.updateSchedules(accessData).subscribe(() => {
      this.isLoading = false;
      this.submitted = false;
      this.activeModal.close(true);
      this.spinnerService.hide();
    });
  }

  get optionsData(): FormArray {
    return this.scheduleForm.get('options') as FormArray;
  }

  removeOption(i: number) {
    this.modalService
      .confirm('Are you sure that you want to remove this ?')
      .pipe(take(1))
      .subscribe((confirmed: any) => {
        if (confirmed) {
          this.optionsData.removeAt(i);
        }
      });
  }

  get wearableOptionsData(): FormArray {
    return this.scheduleForm.get('wearableOptions') as FormArray;
  }

  addWearable() {
    if (this.wearableOptionsData.valid) {
      this.wearableOptionsData.push(this.newWearableOption());
    } else {
      return;
    }
  }

  removeWearableOption(i: number) {
    this.modalService
      .confirm('Are you sure that you want to remove this ?')
      .pipe(take(1))
      .subscribe((confirmed: any) => {
        if (confirmed) {
          this.wearableOptionsData.removeAt(i);
        }
      });
  }

  addNewOption() {
    if (this.optionsData.valid) {
      this.optionsData.push(this.newOption());
    } else {
      return;
    }
  }

  getSurveys() {
    this.isLoading = true;
    this.surveyService.getSurveysByStudyId().subscribe(
      (surveys: Survey[]) => {
        if (surveys.length) {
          this.surveyDataTable = [...surveys, ...this.arr];
          this.surveyDataTable = [...new Map(this.surveyDataTable.map((item: any) => [item['uuid'], item])).values()];
          console.log(this.surveyDataTable);
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  getUserGroups() {
    this.userGroupService.getUserGroups().subscribe({
      next: (groups: UserGroupFormModel[]): void => {
        this.userGroups = groups;
      },
    });
  }

  getEmailTemplates() {
    this.emailTemplatesService.getEmailTemplatesByStudyId().subscribe((emailTemplate) => {
      this.emailTemplate = emailTemplate;
    });
  }

  toggleEmailTemplates(isChecked: boolean) {
    this.showEmailTemplates = isChecked;
    if (!isChecked) {
      this.scheduleForm.value.emailTemplateId = null;
      this.scheduleForm.value.userGroupId = null;
      this.scheduleForm.controls['emailTemplateId'].setValidators(null);
      this.scheduleForm.controls['userGroupId'].setValidators(null);
      this.scheduleForm.controls['emailTemplateId'].setErrors(null);
      this.scheduleForm.controls['userGroupId'].setErrors(null);
    } else {
      this.scheduleForm.controls['emailTemplateId'].setValidators([Validators.required()]);
      this.scheduleForm.controls['userGroupId'].setValidators([Validators.required()]);
    }
  }
}
